import React, { useState } from 'react'
import { Spin } from 'antd';
import { FILE_OFFNET_HINT } from '../helper/blobFileUrl'

function ImageLoad({show, url}) {
  const [isImgLoaded, setIsImgLoaded] = useState(false)
  const [isError, setIsError] = useState(false)
  return (<div style={show ?{ minHeight:'30vh'}: {display:'none'}}>
    {isError
      ? <div style={{ minHeight:'30vh', display:'flex', alignItems:'center', justifyContent:'center', textAlign:'center', color:'#d46b08', padding:'20px' }}>
          {FILE_OFFNET_HINT}
        </div>
      : <Spin style={{ position: 'fixed', top: '25%' }} tip="Loading..." spinning={!isImgLoaded}>
          <img
            style={{maxHeight: '60vh', maxWidth: '100%', minHeight:'30vh'}}
            onLoad={() => setIsImgLoaded(true)}
            onError={() => { setIsImgLoaded(true); setIsError(true); }}
            src={url}
            alt=""
          />
        </Spin>
    }
  </div>
  )
}

export default ImageLoad
